import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Check if MFA is enabled
 */
export default async function checkMFAEnabled(): Promise<{
  mfa_enabled: boolean;
}> {
  const res = await fetchOrchidAPI("/api/users/v1/check_mfa_enabled", {
    method: "GET",
  });
  if (!res.ok) {
    throw new Error(getErrorDetail(await res.text()));
  }

  return res.json();
}
